import { render, staticRenderFns } from "./PopupRef.vue?vue&type=template&id=18416c61&scoped=true"
import script from "./PopupRef.vue?vue&type=script&lang=js"
export * from "./PopupRef.vue?vue&type=script&lang=js"
import style0 from "./PopupRef.vue?vue&type=style&index=0&id=18416c61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18416c61",
  null
  
)

export default component.exports